import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Wysiwyg from "../components/wysiwyg.react";
import InputCustom from "../components/inputCustom.react";
import TextArea from "../components/textarea.react";
import MediaEdit from "../components/mediaEdit.react";
import CheckboxCustom from "../components/checkboxCustom.react";
import Select from "react-select";
import Gallery from "../galleries/gallery.react";

export default class PageEdit extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.getPageTranslation();
  }

  componentDidUpdate(prevProps) {
    const { params: { slug } } = this.props;
    const { params: { slug: prevSlug } } = prevProps;
    if (slug !== prevSlug) {
      this.getPageTranslation();
    }
  }

  getPageTranslation = () => {
    const {
      actions,
      notificationSystem,
      params: { slug },
      locales: { locales: { defaultLocale } },
      pages: { pages: { meta: pagesMeta } }
    } = this.props;
    actions
      .getPages(pagesMeta)
      .then(({ error: pagesError, payload: pagesPayload }) => {
        if (pagesError) {
          addNotificationsForInvalidFields(pagesPayload, notificationSystem);
        } else {
          actions.getPagesTranslation(slug).then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            } else {
              const sections =
                payload.entities.pageTranslations[payload.result]
                  .pageTranslations[defaultLocale].sections;
              for (let sectionName in sections) {
                for (let fieldName in sections[sectionName].fields) {
                  if (
                    sections[sectionName].fields[fieldName].fieldType ===
                    "resourceURL"
                  ) {
                    pagesPayload.result.pages.forEach(function(page, index) {
                      if (
                        `/${pagesPayload.entities.pages[page].pageTranslations[
                          defaultLocale
                        ].slug}` ===
                        sections[sectionName].fields[fieldName].value
                      ) {
                        actions.setEntityField(
                          "fields",
                          sections[sectionName].fields[fieldName].uid,
                          "value",
                          `page:${pagesPayload.entities.pages[page]
                            .pageTranslations[defaultLocale].uid}`
                        );
                      }
                    });
                  }
                }
              }
            }
          });
        }
      });
  };

  dropAction = () => {
    const {
      settings: { draggingItemUID, hoveringItemUID },
      fields: { fields: { entities: fields } },
      actions,
      params: { slug },
      notificationSystem
    } = this.props;
    const dragField = fields.get(draggingItemUID);
    const dropField = fields.get(hoveringItemUID);
    actions
      .updateField(fields.get(draggingItemUID), draggingItemUID)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
        this.getPageTranslation(slug);
      });
  };

  onResourceUrlSelect = (value, options) => {
    const { actions } = this.props;
    actions.setEntityField(
      "fields",
      options[0].fieldUID,
      "value",
      `page:${options[0].pageUID}`
    );
  };

  generateEditPage = columnNumber => {
    const {
      galleryItems: {
        galleryItems: {
          isRemoveModalVisible: isRemoveGalleryItemModalVisible,
          isEditModalVisible: isEditGalleryItemModalVisible,
          entities: galleryItems
        }
      },
      galleries: {
        forms: { createGalleryGalleryItem },
        galleries: { entities: galleries }
      },
      pages: { pages: { entities: pages } },
      settings: { draggingItemUID, hoveringItemUID },
      config: { apiHost },
      medias: {
        medias: {
          meta: mediasMeta,
          selectedMediaItem,
          entities: medias,
          loading,
          results: mediasResults
        }
      },
      mediaCategories: {
        mediaCategories: {
          search: mediaCategoriesSearch,
          entities: mediaCategories
        }
      },
      actions,
      params: { slug },
      pageTranslations: {
        pageTranslations: {
          isEditMediaFieldModalVisible,
          entities: pageTranslations
        }
      },
      fields: { fields: { entities: fields } },
      locales: { locales: { defaultLocale } },
      notificationSystem
    } = this.props;

    const self = this;
    let isEmpty = true;
    let fieldsHTML = [];
    let galleriesHTML = [];
    let sectionsHTML = [];
    if (
      pageTranslations.getIn([
        slug,
        "pageTranslations",
        defaultLocale,
        "sections"
      ])
    ) {
      pageTranslations
        .getIn([slug, "pageTranslations", defaultLocale, "sections"])
        .sort((a, b) => a.get("sort") - b.get("sort"))
        .forEach(function(section, sectionIndex) {
          if (section.get("columnNumber") === columnNumber) {
            isEmpty = false;
            fieldsHTML = section.get("fields")
              ? section
                  .get("fields")
                  .sort(
                    (a, b) =>
                      fields.getIn([a.get("uid"), "sort"]) -
                      fields.getIn([b.get("uid"), "sort"])
                  )
                  .valueSeq()
                  .map(function(fieldObject, fieldIndex) {
                    let field = fields.get(fieldObject.get("uid"));
                    if (field) {
                      const inputCustomProps = {
                        feature: "fields",
                        actions: actions,
                        field: ["value"],
                        entity: field,
                        uid: field.get("uid"),
                        placeholder: field.get("placeholder")
                      };

                      if (field.get("fieldType") === "boolean") {
                        return (
                          <div className="col-xs-12" key={fieldIndex}>
                            <div className="content-wrapper section">
                              <div className="section-title">
                                {field.get("name")}
                              </div>
                              <CheckboxCustom
                                {...inputCustomProps}
                                checked={field.get("value")}
                                id={field.get("uid")}
                                disabled={false}
                              />
                            </div>
                          </div>
                        );
                      } else if (field.get("fieldType") === "text") {
                        return (
                          <div className="col-xs-12" key={fieldIndex}>
                            <div className="content-wrapper section">
                              <span className="section-title">
                                {field.get("name")}
                              </span>
                              <TextArea
                                className="edit-textarea"
                                {...inputCustomProps}
                              />
                            </div>
                          </div>
                        );
                      } else if (field.get("fieldType") === "videoEmbed") {
                        return (
                          <div className="col-xs-12" key={fieldIndex}>
                            <div className="content-wrapper section">
                              <div className="section-title">
                                {field.get("name")}
                              </div>
                              <InputCustom {...inputCustomProps} />
                            </div>
                          </div>
                        );
                      } else if (field.get("fieldType") === "currency") {
                        return (
                          <div className="col-xs-12" key={fieldIndex}>
                            <div className="content-wrapper section">
                              <div className="section-title">
                                {field.get("name")}
                              </div>
                              <InputCustom
                                {...inputCustomProps}
                                type="number"
                              />
                            </div>
                          </div>
                        );
                      } else if (field.get("fieldType") === "wysiwyg") {
                        return (
                          <div className="col-xs-12" key={fieldIndex}>
                            <div className="content-wrapper section">
                              <div className="section-title">
                                {field.get("name")}
                                <div className="subtitle">
                                  Aby zmienić / uzupełnić treść, kliknij
                                  poniżej.
                                </div>
                              </div>
                              <Wysiwyg
                                {...inputCustomProps}
                                content={fieldObject.get("value")}
                                id={"wysiwyg" + fieldObject.get("uid")}
                              />
                            </div>
                          </div>
                        );
                      } else if (field.get("fieldType") === "imageURL") {
                        return (
                          <MediaEdit
                            key={fieldIndex}
                            mediasResults={mediasResults}
                            meta={mediasMeta}
                            field={field}
                            actions={actions}
                            apiHost={apiHost}
                            medias={medias}
                            mediaCategoriesSearch={mediaCategoriesSearch}
                            mediaCategories={mediaCategories}
                            isEditMediaFieldModalVisible={
                              isEditMediaFieldModalVisible
                            }
                            selectedMediaItem={selectedMediaItem}
                            loading={loading}
                          />
                        );
                      } else if (field.get("fieldType") === "mediaImage") {
                        return (
                          <MediaEdit
                            key={fieldIndex}
                            mediasResults={mediasResults}
                            meta={mediasMeta}
                            field={field}
                            actions={actions}
                            apiHost={apiHost}
                            medias={medias}
                            mediaCategoriesSearch={mediaCategoriesSearch}
                            mediaCategories={mediaCategories}
                            isEditMediaFieldModalVisible={
                              isEditMediaFieldModalVisible
                            }
                            selectedMediaItem={selectedMediaItem}
                            loading={loading}
                          />
                        );
                      } else if (field.get("fieldType") === "resourceURL") {
                        let resourceUrlSelectOptions = [];
                        let value = "";
                        pages.forEach(function(page, index) {
                          resourceUrlSelectOptions.push({
                            value: page.getIn([
                              "pageTranslations",
                              defaultLocale,
                              "slug"
                            ]),
                            pageUID: page.getIn([
                              "pageTranslations",
                              defaultLocale,
                              "uid"
                            ]),
                            fieldUID: field.get("uid"),
                            label: page.getIn([
                              "pageTranslations",
                              defaultLocale,
                              "name"
                            ])
                          });
                          if (
                            `/${page.getIn([
                              "pageTranslations",
                              defaultLocale,
                              "slug"
                            ])}` === field.get("value")
                          ) {
                            value = page.getIn([
                              "pageTranslations",
                              defaultLocale,
                              "name"
                            ]);
                          } else if (
                            `page:${page.getIn([
                              "pageTranslations",
                              defaultLocale,
                              "uid"
                            ])}` === field.get("value")
                          ) {
                            value = page.getIn([
                              "pageTranslations",
                              defaultLocale,
                              "name"
                            ]);
                          }
                        });
                        return (
                          <div className="col-xs-12" key={fieldIndex}>
                            <div className="content-wrapper section">
                              <div className="section-title">
                                {field.get("name")}
                              </div>
                              <Select
                                name="select-resource-url"
                                value={value}
                                options={resourceUrlSelectOptions}
                                onChange={self.onResourceUrlSelect}
                                clearable={false}
                              />
                            </div>
                          </div>
                        );
                      }
                    }
                  })
              : "";
            galleriesHTML = section.getIn(["galleries"])
              ? section
                  .getIn(["galleries"])
                  .valueSeq()
                  .map(function(gallery, index) {
                    gallery = galleries.get(gallery.get("uid"));
                    if (gallery) {
                      const inputCustomProps = {
                        feature: "galleries",
                        actions: actions,
                        entity: gallery,
                        uid: gallery.get("uid"),
                        placeholder: gallery.get("placeholder")
                      };
                      return (
                        <div className="col-xs-12" key={index}>
                          <div className="content-wrapper section">
                            <div className="section-title">
                              {gallery.get("name")}
                            </div>
                            <Gallery
                              galleryItems={galleryItems}
                              gallery={gallery}
                              createGalleryItemForm={createGalleryGalleryItem}
                              actions={actions}
                              notificationSystem={notificationSystem}
                              mediaCategoriesSearch={mediaCategoriesSearch}
                              medias={medias}
                              mediaCategories={mediaCategories}
                              selectedMediaItem={selectedMediaItem}
                              apiHost={apiHost}
                              isEditGalleryItemModalVisible={
                                isEditGalleryItemModalVisible
                              }
                              isRemoveGalleryItemModalVisible={
                                isRemoveGalleryItemModalVisible
                              }
                              updateDataFromServerAction={
                                self.getPageTranslation
                              }
                              mediasResults={mediasResults}
                              meta={mediasMeta}
                            />
                          </div>
                        </div>
                      );
                    }
                  })
              : "";
            sectionsHTML.push(
              <section className="row" key={sectionIndex}>
                <div className="col-xs-12">
                  <div className="box-wrapper with-space">
                    <span className="title with-space">
                      {section.get("name")}
                    </span>
                    {fieldsHTML}
                    {galleriesHTML}
                  </div>
                </div>
              </section>
            );
          }
        });
    }
    if (isEmpty) {
      return null;
    } else {
      return sectionsHTML;
    }
  };

  publish = () => {
    const {
      actions,
      params: { slug },
      pageTranslations: { pageTranslations: { entities: pageTranslations } },
      fields: { fields: { entities: fields } },
      galleries: { galleries: { entities: galleries } },
      locales: { locales: { defaultLocale } },
      history,
      notificationSystem
    } = this.props;

    const pageTranslationSections = pageTranslations.getIn([
      slug,
      "pageTranslations",
      defaultLocale,
      "sections"
    ]);
    let pageTranslationSectionsIndex = 0;

    pageTranslationSections.map(function(section, sectionIndex) {
      pageTranslationSectionsIndex++;

      const galleryLength = section.get("galleries").size;
      const fieldsLength = section.get("fields").size;

      let galleryCount = 0;
      let fieldsCount = 0;

      section.get("galleries").map(function(gallery, galleryIndex) {
        actions
          .updateGallery(galleries.get(gallery.get("uid")), gallery.get("uid"))
          .then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            } else {
              galleryCount++;
              if (
                pageTranslationSectionsIndex === pageTranslationSections.size &&
                galleryCount === galleryLength &&
                fieldsCount === fieldsLength
              ) {
                let notification = {
                  level: "success",
                  message: "Opublikowano wpis!",
                  position: "br",
                  autoDismiss: 5,
                  dismissible: true
                };
                notificationSystem.addNotification(notification);
              }
            }
          });
      });

      section.get("fields").map(function(field, fieldIndex) {
        actions
          .updateField(fields.get(field.get("uid")), field.get("uid"))
          .then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            } else {
              fieldsCount++;
              if (
                pageTranslationSectionsIndex === pageTranslationSections.size &&
                galleryCount === galleryLength &&
                fieldsCount === fieldsLength
              ) {
                let notification = {
                  level: "success",
                  message: "Opublikowano wpis!",
                  position: "br",
                  autoDismiss: 5,
                  dismissible: true
                };
                notificationSystem.addNotification(notification);
              }
            }
          });
      });
    });

    if (
      pageTranslations.getIn([
        slug,
        "pageTranslations",
        defaultLocale,
        "slug"
      ]) !== slug
    ) {
      const data = {
        slug: pageTranslations.getIn([
          slug,
          "pageTranslations",
          defaultLocale,
          "slug"
        ])
      };

      const uid = pageTranslations.getIn([
        slug,
        "pageTranslations",
        defaultLocale,
        "uid"
      ]);
      actions.updatePagesTranslation(data, uid).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          actions.setShouldMenuLeftRerender(true);
          history.pushState("/pages/:slug", `/pages/${data.slug}`, {});
        }
      });
    }
  };

  render() {
    const {
      pageTranslations: { pageTranslations: { entities: pageTranslations } },
      params: { slug },
      locales: { locales: { defaultLocale } },
      actions,
      config: { siteHost }
    } = this.props;
    const contentLeft = this.generateEditPage(1);
    const contentRight = this.generateEditPage(2);
    const inputCustomProps = {
      feature: "pageTranslations",
      actions: actions,
      entity: pageTranslations.get(slug),
      field: ["pageTranslations", defaultLocale, "slug"],
      uid: slug,
      className: "slug-change"
    };
    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <h2 className="col-xs-12 slug">
            {pageTranslations.getIn([
              slug,
              "pageTranslations",
              defaultLocale,
              "name"
            ])}
          </h2>
          <div className="col-xs-12 slug-change">
            <svg
              version="1.1"
              viewBox="0 0 80 80"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path d="M29.298,63.471l-4.048,4.02c-3.509,3.478-9.216,3.481-12.723,0c-1.686-1.673-2.612-3.895-2.612-6.257   s0.927-4.585,2.611-6.258l14.9-14.783c3.088-3.062,8.897-7.571,13.131-3.372c1.943,1.93,5.081,1.917,7.01-0.025   c1.93-1.942,1.918-5.081-0.025-7.009c-7.197-7.142-17.834-5.822-27.098,3.37L5.543,47.941C1.968,51.49,0,56.21,0,61.234   s1.968,9.743,5.544,13.292C9.223,78.176,14.054,80,18.887,80c4.834,0,9.667-1.824,13.348-5.476l4.051-4.021   c1.942-1.928,1.953-5.066,0.023-7.009C34.382,61.553,31.241,61.542,29.298,63.471z M74.454,6.044   c-7.73-7.67-18.538-8.086-25.694-0.986l-5.046,5.009c-1.943,1.929-1.955,5.066-0.025,7.009c1.93,1.943,5.068,1.954,7.011,0.025   l5.044-5.006c3.707-3.681,8.561-2.155,11.727,0.986c1.688,1.673,2.615,3.896,2.615,6.258c0,2.363-0.928,4.586-2.613,6.259   l-15.897,15.77c-7.269,7.212-10.679,3.827-12.134,2.383c-1.943-1.929-5.08-1.917-7.01,0.025c-1.93,1.942-1.918,5.081,0.025,7.009   c3.337,3.312,7.146,4.954,11.139,4.954c4.889,0,10.053-2.462,14.963-7.337l15.897-15.77C78.03,29.083,80,24.362,80,19.338   C80,14.316,78.03,9.595,74.454,6.044z" />
              </g>
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
            </svg>
            {siteHost + "/"}
            <InputCustom {...inputCustomProps} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-8">{contentLeft}</div>
          <div className="col-xs-4">{contentRight}</div>
        </div>
        <div className="col-xs-12">
          <button className="success publish" onClick={this.publish}>
            opublikuj
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/pageEdit/pageEdit.react.js